module.exports = __webpack_public_path__ + "img/img61.4eb22aa9.svg";